
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { isMobile } from '@/utils/validate';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  public getLang() {
    return AppModule.language;
  }
  get brandName() {
    const { company } = this.$route.query;
    const currentCompany = Array.isArray(company) ? company[0] || '' : company || '';
    return currentCompany.toUpperCase() === 'GEA' ? 'GEA' : 'GET';
  }
  get isMobile() {
    return isMobile();
  }
}
